const model = {
    submitting: false,
    success: '',
    loading: false,
    errors: null,
};

export default model;
